module.exports = __webpack_public_path__ + "img/cite-left.35a6224c.svg";